var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Grid, Select } from "semantic-ui-react";
var ChangeDcvScoreModal = /** @class */ (function (_super) {
    __extends(ChangeDcvScoreModal, _super);
    function ChangeDcvScoreModal(props) {
        var _this = _super.call(this, props) || this;
        _this.dcvScoreOptions = function () {
            var dcvScores = [{
                    text: 'None',
                    value: 'None'
                }];
            return dcvScores.concat(_this.props.dcvScores.map(function (s) { return ({
                text: s.label,
                value: s.id
            }); }));
        };
        _this.onDcvScoreChange = function (event, data) {
            var gId = data.value;
            var dcvScore = _this.props.dcvScores.find(function (dG) { return dG.id === gId; });
            _this.setState({
                dcvScore: dcvScore
            });
        };
        _this.submit = function () {
            var _a;
            _this.props.postRequest("/admin/catalog/rna-cish/organisms/id/" + encodeURIComponent(_this.props.orgId.toString()) + "/probe-set-families/id/" + encodeURIComponent(_this.props.psfId.toString()) + "/variants/id/" + encodeURIComponent(_this.props.variantId.toString()) + "/dcv-score", {
                dcvScore: (_a = _this.state.dcvScore) === null || _a === void 0 ? void 0 : _a.id
            });
        };
        _this.state = {
            dcvScore: _this.props.dcvScore
        };
        return _this;
    }
    ChangeDcvScoreModal.prototype.render = function () {
        return React.createElement(Grid, { columns: 1, centered: true },
            React.createElement(Grid.Row, null,
                React.createElement("p", null,
                    "Are you sure you want to change the dcv score for variant ",
                    this.props.variantId)),
            React.createElement(Grid.Row, null,
                React.createElement(Select, { options: this.dcvScoreOptions(), onChange: this.onDcvScoreChange, value: this.state.dcvScore ? this.state.dcvScore.id : 'None' })),
            React.createElement(Grid.Row, null,
                React.createElement(Button, { label: "Change dcv score", labelPosition: 'left', onClick: this.submit, icon: 'exchange' })));
    };
    return ChangeDcvScoreModal;
}(React.PureComponent));
export default ChangeDcvScoreModal;
//# sourceMappingURL=ChangeDcvScoreModal.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/ChangeDcvScoreModal.js
// module id = 1459
// module chunks = 0